/** @jsx jsx */
import { ClassNames, css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import { GradientWrapper } from '@coursera/coursera-ui';

import { getTranslatedProductName } from 'bundles/browse/utils';

const styles = {
  productTypePill: css`
    font-weight: bold;
    width: fit-content;
    text-decoration: none;
    display: inline-block;
  `,
  withoutGradient: css`
    padding: 0.1875rem 1.125rem;
    font-weight: normal;
  `,
};

type Props = {
  productTypeName?: string;
};

const getGradientColor = () => {
  return { deg: 0, start: '#F0F0F0', end: '#F0F0F0' };
};

const ProductTypePill = (props: Props) => {
  const { productTypeName } = props;
  const productNameTranslated = getTranslatedProductName(productTypeName);

  return (
    <ClassNames>
      {({ css: cssClassName }) => (
        <GradientWrapper
          gradient={getGradientColor()}
          rootClassName={cssClassName([styles.productTypePill, styles.withoutGradient])}
        >
          <Typography2 variant="bodyPrimary" component="span">
            {productNameTranslated}
          </Typography2>
        </GradientWrapper>
      )}
    </ClassNames>
  );
};

export default ProductTypePill;
